import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Header from "../../stories/components/Header.js";
import LogoTableRow from "../../stories/components/LogoTableRow";
import LogoTableHead from "../../stories/components/LogoTableHead";

import {
  LogoVestlandPrimaerBokmaalNegativPdf,
  LogoVestlandPrimaerBokmaalNegativPng,
  LogoVestlandPrimaerBokmaalNegativSvg,
  LogoVestlandPrimaerBokmaalPositivPdf,
  LogoVestlandPrimaerBokmaalPositivPng,
  LogoVestlandPrimaerBokmaalPositivSvg,
  LogoVestlandPrimaerBokmaalEngelskNegativPdf,
  LogoVestlandPrimaerBokmaalEngelskNegativPng,
  LogoVestlandPrimaerBokmaalEngelskNegativSvg,
  LogoVestlandPrimaerBokmaalEngelskPositivPdf,
  LogoVestlandPrimaerBokmaalEngelskPositivPng,
  LogoVestlandPrimaerBokmaalEngelskPositivSvg,
  LogoVestlandPrimaerNynorskNegativPdf,
  LogoVestlandPrimaerNynorskNegativPng,
  LogoVestlandPrimaerNynorskNegativSvg,
  LogoVestlandPrimaerNynorskPositivPdf,
  LogoVestlandPrimaerNynorskPositivPng,
  LogoVestlandPrimaerNynorskPositivSvg,
  LogoVestlandPrimaerNynorskEngelskNegativPdf,
  LogoVestlandPrimaerNynorskEngelskNegativPng,
  LogoVestlandPrimaerNynorskEngelskNegativSvg,
  LogoVestlandPrimaerNynorskEngelskPositivPdf,
  LogoVestlandPrimaerNynorskEngelskPositivPng,
  LogoVestlandPrimaerNynorskEngelskPositivSvg,
  LogoVestlandSekundaerBokmaalNegativPdf,
  LogoVestlandSekundaerBokmaalNegativPng,
  LogoVestlandSekundaerBokmaalNegativSvg,
  LogoVestlandSekundaerBokmaalPositivPdf,
  LogoVestlandSekundaerBokmaalPositivPng,
  LogoVestlandSekundaerBokmaalPositivSvg,
  LogoVestlandSekundaerBokmaalEngelskNegativPdf,
  LogoVestlandSekundaerBokmaalEngelskNegativPng,
  LogoVestlandSekundaerBokmaalEngelskNegativSvg,
  LogoVestlandSekundaerBokmaalEngelskPositivPdf,
  LogoVestlandSekundaerBokmaalEngelskPositivPng,
  LogoVestlandSekundaerBokmaalEngelskPositivSvg,
  LogoVestlandSekundaerNynorskNegativPdf,
  LogoVestlandSekundaerNynorskNegativPng,
  LogoVestlandSekundaerNynorskNegativSvg,
  LogoVestlandSekundaerNynorskPositivPdf,
  LogoVestlandSekundaerNynorskPositivPng,
  LogoVestlandSekundaerNynorskPositivSvg,
  LogoVestlandSekundaerNynorskEngelskNegativPdf,
  LogoVestlandSekundaerNynorskEngelskNegativPng,
  LogoVestlandSekundaerNynorskEngelskNegativSvg,
  LogoVestlandSekundaerNynorskEngelskPositivPdf,
  LogoVestlandSekundaerNynorskEngelskPositivPng,
  LogoVestlandSekundaerNynorskEngelskPositivSvg,
  LogoVestlandSentrertBokmaalNegativPdf,
  LogoVestlandSentrertBokmaalNegativPng,
  LogoVestlandSentrertBokmaalNegativSvg,
  LogoVestlandSentrertBokmaalPositivPdf,
  LogoVestlandSentrertBokmaalPositivPng,
  LogoVestlandSentrertBokmaalPositivSvg,
  LogoVestlandSentrertBokmaalEngelskNegativPdf,
  LogoVestlandSentrertBokmaalEngelskNegativPng,
  LogoVestlandSentrertBokmaalEngelskNegativSvg,
  LogoVestlandSentrertBokmaalEngelskPositivPdf,
  LogoVestlandSentrertBokmaalEngelskPositivPng,
  LogoVestlandSentrertBokmaalEngelskPositivSvg,
  LogoVestlandSentrertNynorskNegativPdf,
  LogoVestlandSentrertNynorskNegativPng,
  LogoVestlandSentrertNynorskNegativSvg,
  LogoVestlandSentrertNynorskPositivPdf,
  LogoVestlandSentrertNynorskPositivPng,
  LogoVestlandSentrertNynorskPositivSvg,
  LogoVestlandSentrertNynorskEngelskNegativPdf,
  LogoVestlandSentrertNynorskEngelskNegativPng,
  LogoVestlandSentrertNynorskEngelskNegativSvg,
  LogoVestlandSentrertNynorskEngelskPositivPdf,
  LogoVestlandSentrertNynorskEngelskPositivPng,
  LogoVestlandSentrertNynorskEngelskPositivSvg,
} from "../../assets/logo/Vestland/exportVestland.js";

export default function VestlandPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Logofiler for Statsforvalteren i Vestland"
          lead="Alle logoer for Vestland i ulike variasjoner og filformater"
          breadcrumbText="Tilbake til logo"
          breadcrumbUrl="/logo"
        />
        <main>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <p>Tekst om logovarianter og filformater...</p>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Primærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                  <LogoTableRow
                    logoUrl={LogoVestlandPrimaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestland, bokmål"
                    text="Bokmål"
                    blackSvg={LogoVestlandPrimaerBokmaalPositivSvg}
                    blackPng={LogoVestlandPrimaerBokmaalPositivPng}
                    blackPdf={LogoVestlandPrimaerBokmaalPositivPdf}
                    whiteSvg={LogoVestlandPrimaerBokmaalNegativSvg}
                    whitePng={LogoVestlandPrimaerBokmaalNegativPng}
                    whitePdf={LogoVestlandPrimaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestlandPrimaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestland, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoVestlandPrimaerBokmaalEngelskPositivSvg}
                    blackPng={LogoVestlandPrimaerBokmaalEngelskPositivPng}
                    blackPdf={LogoVestlandPrimaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoVestlandPrimaerBokmaalEngelskNegativSvg}
                    whitePng={LogoVestlandPrimaerBokmaalEngelskNegativPng}
                    whitePdf={LogoVestlandPrimaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestlandPrimaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestland, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoVestlandPrimaerNynorskPositivSvg}
                    blackPng={LogoVestlandPrimaerNynorskPositivPng}
                    blackPdf={LogoVestlandPrimaerNynorskPositivPdf}
                    whiteSvg={LogoVestlandPrimaerNynorskNegativSvg}
                    whitePng={LogoVestlandPrimaerNynorskNegativPng}
                    whitePdf={LogoVestlandPrimaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestlandPrimaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestland, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoVestlandPrimaerNynorskEngelskPositivSvg}
                    blackPng={LogoVestlandPrimaerNynorskEngelskPositivPng}
                    blackPdf={LogoVestlandPrimaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoVestlandPrimaerNynorskEngelskNegativSvg}
                    whitePng={LogoVestlandPrimaerNynorskEngelskNegativPng}
                    whitePdf={LogoVestlandPrimaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sekundærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                  <LogoTableRow
                    logoUrl={LogoVestlandSekundaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestland, bokmål"
                    text="Bokmål"
                    blackSvg={LogoVestlandSekundaerBokmaalPositivSvg}
                    blackPng={LogoVestlandSekundaerBokmaalPositivPng}
                    blackPdf={LogoVestlandSekundaerBokmaalPositivPdf}
                    whiteSvg={LogoVestlandSekundaerBokmaalNegativSvg}
                    whitePng={LogoVestlandSekundaerBokmaalNegativPng}
                    whitePdf={LogoVestlandSekundaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestlandSekundaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestland, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoVestlandSekundaerBokmaalEngelskPositivSvg}
                    blackPng={LogoVestlandSekundaerBokmaalEngelskPositivPng}
                    blackPdf={LogoVestlandSekundaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoVestlandSekundaerBokmaalEngelskNegativSvg}
                    whitePng={LogoVestlandSekundaerBokmaalEngelskNegativPng}
                    whitePdf={LogoVestlandSekundaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestlandSekundaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestland, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoVestlandSekundaerNynorskPositivSvg}
                    blackPng={LogoVestlandSekundaerNynorskPositivPng}
                    blackPdf={LogoVestlandSekundaerNynorskPositivPdf}
                    whiteSvg={LogoVestlandSekundaerNynorskNegativSvg}
                    whitePng={LogoVestlandSekundaerNynorskNegativPng}
                    whitePdf={LogoVestlandSekundaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestlandSekundaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestland, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoVestlandSekundaerNynorskEngelskPositivSvg}
                    blackPng={LogoVestlandSekundaerNynorskEngelskPositivPng}
                    blackPdf={LogoVestlandSekundaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoVestlandSekundaerNynorskEngelskNegativSvg}
                    whitePng={LogoVestlandSekundaerNynorskEngelskNegativPng}
                    whitePdf={LogoVestlandSekundaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sentert logo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                  <LogoTableRow
                    logoUrl={LogoVestlandSentrertBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestland, bokmål"
                    text="Bokmål"
                    blackSvg={LogoVestlandSentrertBokmaalPositivSvg}
                    blackPng={LogoVestlandSentrertBokmaalPositivPng}
                    blackPdf={LogoVestlandSentrertBokmaalPositivPdf}
                    whiteSvg={LogoVestlandSentrertBokmaalNegativSvg}
                    whitePng={LogoVestlandSentrertBokmaalNegativPng}
                    whitePdf={LogoVestlandSentrertBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestlandSentrertBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestland, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoVestlandSentrertBokmaalEngelskPositivSvg}
                    blackPng={LogoVestlandSentrertBokmaalEngelskPositivPng}
                    blackPdf={LogoVestlandSentrertBokmaalEngelskPositivPdf}
                    whiteSvg={LogoVestlandSentrertBokmaalEngelskNegativSvg}
                    whitePng={LogoVestlandSentrertBokmaalEngelskNegativPng}
                    whitePdf={LogoVestlandSentrertBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestlandSentrertNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestland, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoVestlandSentrertNynorskPositivSvg}
                    blackPng={LogoVestlandSentrertNynorskPositivPng}
                    blackPdf={LogoVestlandSentrertNynorskPositivPdf}
                    whiteSvg={LogoVestlandSentrertNynorskNegativSvg}
                    whitePng={LogoVestlandSentrertNynorskNegativPng}
                    whitePdf={LogoVestlandSentrertNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestlandSentrertNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestland, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoVestlandSentrertNynorskEngelskPositivSvg}
                    blackPng={LogoVestlandSentrertNynorskEngelskPositivPng}
                    blackPdf={LogoVestlandSentrertNynorskEngelskPositivPdf}
                    whiteSvg={LogoVestlandSentrertNynorskEngelskNegativSvg}
                    whitePng={LogoVestlandSentrertNynorskEngelskNegativPng}
                    whitePdf={LogoVestlandSentrertNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}
